import { useEffect, useState } from 'react'
import { UserCog } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/contexts/AuthContext'

// Persistent, impossible-to-miss banner rendered at the app-shell level
// (mounted in Layout.tsx) whenever an admin is viewing another user's
// session — see AuthContext.startImpersonation / POST
// /admin/users/{id}/impersonate. Ticks its own countdown rather than relying
// on a re-render trigger elsewhere.
export function ImpersonationBanner() {
  const { impersonation, exitImpersonation } = useAuth()
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!impersonation) return
    const interval = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(interval)
  }, [impersonation])

  if (!impersonation) return null

  const remainingMs = Math.max(0, impersonation.expiresAt - now)
  const minutes = Math.floor(remainingMs / 60000)
  const seconds = Math.floor((remainingMs % 60000) / 1000)

  return (
    <div className="flex items-center justify-between gap-3 border-b border-amber-500/40 bg-amber-500/15 px-4 py-2 text-sm text-amber-900 dark:text-amber-200">
      <div className="flex items-center gap-2">
        <UserCog className="h-4 w-4 shrink-0" />
        <span>
          Viewing as <strong>{impersonation.targetEmail}</strong> — session ends in{' '}
          {minutes}:{seconds.toString().padStart(2, '0')}
        </span>
      </div>
      <Button size="sm" variant="outline" className="border-amber-600 text-amber-900 dark:text-amber-200" onClick={() => exitImpersonation()}>
        Exit
      </Button>
    </div>
  )
}
